var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMillustrationsTwitter = function SvgMillustrationsTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.04,
    d: "M0 2a2 2 0 0 1 2-2h52a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 23,
    x: 8.5,
    y: 8.5,
    fill: "#fff",
    stroke: "#CCCCD9",
    rx: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8A99",
    fillRule: "evenodd",
    d: "M25.96 24.47a6.38 6.38 0 0 0 6.42-6.42v-.295a4.7 4.7 0 0 0 1.12-1.165c-.412.18-.848.3-1.295.355a2.28 2.28 0 0 0 1-1.25c-.441.264-.925.45-1.43.55a2.26 2.26 0 0 0-3.85 2.055 6.4 6.4 0 0 1-4.65-2.355 2.255 2.255 0 0 0 .7 3 2.2 2.2 0 0 1-1-.28v.025a2.265 2.265 0 0 0 1.775 2.225 2.3 2.3 0 0 1-1 .04 2.255 2.255 0 0 0 2.09 1.545 4.53 4.53 0 0 1-2.805 1 5 5 0 0 1-.535-.045 6.4 6.4 0 0 0 3.46 1",
    clipRule: "evenodd"
  })));
};
export default SvgMillustrationsTwitter;